export const environment = {
  production: true,
  apiUrl: 'https://chat2.drafters.com',
  draftUrl: 'https://draft2.drafters.com',
  chatUrl: 'https://chat2.drafters.com',
  boxScoreUrl: 'https://node.drafters.com',
  adminUrl: 'https://admin.drafters.com',
  phpApiUrl: 'https://api.drafters.com',
  phpUrl: 'https://drafters.com',
  assetURL: 'https://cdn.drafters.com',
  bucketOrigin: 'https://draftersnewprod.s3.amazonaws.com',
  assetUploadURL: 'https://cdn.drafters.com/assets/uploads',
  tournament: 'tournament',
  DRAFT_ACCESS_TOKEN: 'draft_user',
  SITE_URL: 'https://drafters.com',
  leagueURL: 'https://drafters.com/league/profile',
  myTeamURL: 'https://drafters.com/manage-league/my-team',
  matchUpURL: 'https://drafters.com/league/matchup',
  playerURL: 'https://drafters.com/manage-league/players',
  settingsURL: 'https://drafters.com/league/settings',
  CURRENCY_SYMBOL: '$',
  SITE_CURRENCY: 'USD',
  PAYPAL_CLIENT_ID: 'AdnVIInZbouOIatrwGPm_PAltcMneqFsJz7Nzlx9AetXmLGppH3NmciM1BpLFMFx_gL8i1TOJXVtQ9-t',
  SITE_TITLE: 'Drafters',
  S3_ACCESS_KEY: 'AKIAQSPDYLZKTFUFSLLB',
  S3_SECRET_KEY: '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',
  AWS_REGION: 'us-east-1',
  AWS_BUCKET: 'draftersnewprod',
  AWS_BUCKET_DIRECTORY: 'assets/uploads/chat/',
  ANGULAR_FOLDER_NMAE:'drafts',
  ONE_SIGNAL_APP_ID : '1d6f9668-1955-41b5-871f-bf5077b35159',
  REST_API_KEY : 'MWJlZmUxZmMtMjJmMC00Yjg3LTk2NWEtNzZiNDVkYWExMzRm',
  PAYPAL_MERCHANT_ID : 'AL7TWPC4TRNBL',
  NEW_SITE_URL: 'https://drafters.com/draftsv2',
  IS_PHONE_VERIFICATION :false
};